import React, { Component } from 'react';
import RobotList  from '../components/RobotList';
import SearchBox from '../components/SearchBox';
import Scroll from '../components/Scroll';
import ErrorBoundary from '../components/ErrorBoundary';
import './App.css';



class App extends Component{
	constructor(){
		super()
		this.state = {
			robots: [],
			searchfield:''
		}
	}
	componentDidMount(){
	fetch('https://jsonplaceholder.typicode.com/users')
		.then(response => response.json())
		.then(users=>this.setState({robots : users}))
	}

	onSearchChange = (event) =>{
		this.setState({ searchfield: event.target.value})
	}
	
	render(){
		const filteredRobots = this.state.robots.filter(robots => {
		 	return robots.name.toLowerCase().includes(this.state.searchfield.toLowerCase())
	})

		return(
		<div className="tc">
		<h1> ROBOFRIENDS </h1>
		<SearchBox searchChange = { this.onSearchChange }/>
		<Scroll>
		<ErrorBoundary>
		<RobotList robots = { filteredRobots }/>
		</ErrorBoundary>
		</Scroll>
		</div>
		 );
		

	}

}
export default App;